<template>
    <div class="">
        <div class="row no-gutters py-3">
            <div class="col-sm-9 px-4 company-form-box-title">Payment Bank Information</div>
            <template v-if="$acl['banks'] == 2"><div class="col-sm-3 px-4 cursor-pointer text-right company-form-box-title" @click="addNew()"><button class="edit-icon"><i class="fa fa-plus"></i></button></div></template>
        </div>

        <!-- alpha fix- amked the title dynamic  -->
        <b-modal id="bv-modal-payment-bank" size="lg" hide-footer :title=payment_bank_info>
            <b-form @submit.stop.prevent="onSubmit" >
                <div class="clearfix">
                    <div class="row">
                        <div class="col-md-6">
                            <input type="hidden" v-model="fdata.employee_id" name="employee_id">
                            <input type="hidden" v-model="fdata.id" name="id">
                            <b-form-group id="payment_bank_name-group" label="Bank Name" class="required-field" label-for="payment_bank_name">
                                <b-form-select id="payment_bank_name" name="payment_bank_name" v-model="fdata.payment_bank_name" v-validate="{ required: true }" :state="validateState('payment_bank_name')" aria-describedby="payment_bank_name-feedback" data-vv-as="Bank Name" disabled v-if="fdata.id">
                                    <option value="">Select Payment Bank</option>
                                    <option v-for="checked_bank in checked_banks" :key="checked_bank" :value="checked_bank">{{ checked_bank }}</option>
                                </b-form-select>
                                <b-form-select id="payment_bank_name" name="payment_bank_name" v-model="fdata.payment_bank_name" v-validate="{ required: true }" :state="validateState('payment_bank_name')" aria-describedby="payment_bank_name-feedback" data-vv-as="Bank Name" v-else>
                                    <option value="">Select Payment Bank</option>
                                    <option v-for="checked_bank in checked_banks" :key="checked_bank" :value="checked_bank">{{ checked_bank }}</option>
                                </b-form-select>
                                <b-form-invalid-feedback id="payment_bank_name-feedback">{{ veeErrors.first('payment_bank_name') }}</b-form-invalid-feedback>
                            </b-form-group>
                        </div>
                        <div class="col-md-6">
                            <b-form-group id="payment_bank_percentage-group" label="Salary Percentage" class="required-field" label-for="payment_bank_percentage">
                                <b-form-input id="payment_bank_percentage" name="payment_bank_percentage" v-model="fdata.payment_bank_percentage" v-validate="{ required: true, numeric: true, max_value:100 }" :state="validateState('payment_bank_percentage')" aria-describedby="payment_bank_percentage-feedback" data-vv-as="Bank Name"></b-form-input>
                                <b-form-invalid-feedback id="payment_bank_percentage-feedback">{{ veeErrors.first('payment_bank_percentage') }}</b-form-invalid-feedback>
                            </b-form-group>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 mt-4 text-center">
                            <b-button type="submit" class="" variant="primary">Submit</b-button>
                        </div>
                    </div>
                </div>

            </b-form>
        </b-modal>

        <b-overlay :show="showoverlay_list" rounded="sm">
            <div v-if="banks.length > 0" >
                <div class="bank-info-inner" v-for="(bank, index) in banks" :key="bank.id">
                    <div>
                        <template v-if="index==0">
                            <ul class="bank-info" :class="{ 'border-top' : bi==1}">
                                <li class="px-4">
                                    <div class="title col-6">Account Name</div> <!-- Mustafijur: 13-05-2026 -->
                                    <div class="text col-6"> <!-- Mustafijur: 13-05-2026 -->
                                        {{bank.beneficiary_name}}
                                        <div class="action management-bank-action" v-if="$acl['banks'] == 2">
                                            <b-button-toolbar class="float-right position-relative">
                                                <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                                <div class="dropdown-menu action-dropdown-menu px-1 bank-dropdown-menu" aria-labelledby="actionDropdown">
                                                    <b-button-group class="mt-n2">
                                                        <b-button class="border-0 rounded py-0 mt-2" variant="outline-secondary"  title="Edit Bank Account Info" @click="editBankInfo(bank.id)">
                                                            <b-icon icon="pencil-fill" aria-hidden="true" ></b-icon> Edit
                                                        </b-button>
                                                        <b-button class="border-0 rounded py-0" variant="outline-secondary" title="Delete Bank Account Info" @click="deleteBankInfo(bank.id)">
                                                            <b-icon icon="trash" aria-hidden="true"></b-icon> Delete
                                                        </b-button>
                                                    </b-button-group>
                                                </div>
                                            </b-button-toolbar>
                                        </div>
                                    </div>
                                </li>
                                <li class="px-4">
                                    <div class="title col-6">Bank Name</div>
                                    <div class="text col-6"><template v-if="bank.bank_code != 'null'">{{bank.bank_code}}</template></div>
                                </li>
                                <li class="px-4">
                                    <div class="title col-6">Branch Name</div>
                                    <div class="text col-6"><template v-if="bank.branch_name != 'null'">{{bank.branch_name}}</template></div>
                                </li>
                                <li class="px-4">
                                    <div class="title col-6">Bank account No.</div>
                                    <div class="text col-6">{{bank.account_no}}</div>
                                </li>
                                <li class="px-4">
                                    <div class="title col-6">Routing Number</div>
                                    <div class="text col-6"><template v-if="bank.routing_number != 'null'">{{bank.routing_number}}</template></div>
                                </li>
                                <li class="px-4">
                                    <div class="title col-6">Salary Percentage</div>
                                    <div class="text col-6"><template v-if="bank.payment_percetage != 'null'">{{bank.payment_percetage}}%</template></div>
                                </li>
                            </ul>
                        </template>
                        <template v-else>
                            <ul class="bank-info" v-if="bi==1" :class="{ 'border-top' : bi==1}">
                                <li class="px-4 mt-3">
                                    <div class="title col-6">Account Name</div>
                                    <div class="text col-6">
                                        {{bank.beneficiary_name}}
                                        <div class="action" v-if="$acl['banks'] == 2">
                                            <b-button-toolbar class="float-right position-relative">
                                                <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                                <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                                    <b-button-group class="mt-n2">
                                                        <b-button class="border-0 rounded py-0" variant="outline-secondary"  title="Edit Bank Account Info" @click="editBankInfo(bank.id)">
                                                            <b-icon icon="pencil-fill" aria-hidden="true" ></b-icon> Edit
                                                        </b-button>
                                                        <b-button class="border-0 rounded py-0" variant="outline-secondary" title="Delete Bank Account Info" @click="deleteBankInfo(bank.id)">
                                                            <b-icon icon="trash" aria-hidden="true"></b-icon> Delete
                                                        </b-button>
                                                    </b-button-group>
                                                </div>
                                            </b-button-toolbar>
                                        </div>
                                    </div>
                                </li>
                                <li class="px-4">
                                    <div class="title col-6">Bank Name</div>
                                    <div class="text col-6"><template v-if="bank.bank_code != 'null'">{{bank.bank_code}}</template></div>
                                </li>
                                <li class="px-4">
                                    <div class="title col-6">Branch Name</div>
                                    <div class="text col-6"><template v-if="bank.branch_name != 'null'">{{bank.branch_name}}</template></div>
                                </li>
                                <li class="px-4">
                                    <div class="title col-6">Bank account No.</div>
                                    <div class="text col-6">{{bank.account_no}}</div>
                                </li>
                                <li class="px-4">
                                    <div class="title col-6">Routing Number</div>
                                    <div class="text col-6"><template v-if="bank.routing_number != 'null'">{{bank.routing_number}}</template></div>
                                </li>
                                <li class="px-4">
                                    <div class="title col-6">Salary Percentage</div>
                                    <div class="text col-6"><template v-if="bank.payment_percetage != 'null'">{{bank.payment_percetage}}%</template></div>
                                </li>
                            </ul>
                        </template>
                    </div>

                </div>
                <template v-if="banks.length > 0">
                    <div class="more-bank" v-if="bi==0">
                          <b-button class="border-0 rounded p-0" variant="outline-secondary" title="Show all" @click="showAll(1)">
                              Show All <i class="fa fa-angle-down"></i>
                          </b-button>
                    </div>
                    <div class="more-bank" v-if="bi==1">
                          <b-button class="border-0 rounded p-0" variant="outline-secondary" title="Show less" @click="showLess(0)">
                              Show Less <i class="fa fa-angle-up"></i>
                          </b-button>
                    </div>
                </template>
            </div>
        </b-overlay>


    </div>
</template>


<script>
    export default{

        mounted() {

        },
        props: ['bn' , 'flg' , 'employee_id'],
        data(){

            return {

                banks:[],
                bank_names: [
                    { value: null, text: "--Select--" },
                ],
                showoverlay_list : false,
                successmsg:'',
                errormsg:[],
                fdata: {employee_id: this.employee_id, payment_bank_name:null},

                selected_bank_id:0,
                loading:'',
                bi : 0,

                checked_banks: [],
                selected_banks: [],

                // alpha fix- added this
                payment_bank_info: "Payment Bank Info",
            }
        },
        methods:{

            getBankList: function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/banklist/' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){
                    this.bank_names = response.data;
                }.bind(this)).catch(function (error){this.serverError(error);});

            },

              showPrimaryModal: function(bankid)
              {
                this.selected_bank_id=bankid;
                this.$bvModal.show('make-primary-modal');
              },

             showAll :function(x)
            {
                this.bi = x;
            },
             showLess :function(x)
            {
                this.bi = x;
            },


            makePrimary: function(bankid)
            {
                //alert(bankid);

                if(!this.checkNet()) return false;

                this.loading='loading..';
                axios.get(this.$api_url+'/makeprimary/' , {
                    params: {
                        bank_id: bankid

                    }
                }).then(function(response){
                    this.$bvModal.hide('make-primary-modal');
                    this.getBankData();
                    this.loading='';
                }.bind(this)).catch(function (error){this.serverError(error);});

            },

            getBankData: function()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                axios.post(this.$api_url+'/employee-salary-banks' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){
                    this.banks = response.data;
                }.bind(this)).catch(function (error){currentObj.serverError(error);});
            },
            editBankInfo:function(x)
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url+'/salary-banks-details' , {
                    params: {
                        id: x
                    }
                }).then(function(response){
                    this.fdata = {
                        employee_id : this.employee_id,
                        id: response.data.id,
                        payment_bank_name: response.data.bank_code,
                        payment_bank_percentage: response.data.payment_percetage,
                    };
                    this.$bvModal.show('bv-modal-payment-bank');
                    // alpha fix- added this
                    this.payment_bank_info = "Edit Payment Bank Info";
                }.bind(this)).catch(function (error){currentObj.serverError(error);});

            },

            deleteBankInfo:function(x)
            {
                if(!this.checkNet()) return false;
                this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this Bank Info.', {
                    title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false,centered: true
                })
                .then(value => {
                    if(value)
                    {
                        this.resetForm();
                        this.showoverlay_list = true;
                        let currentObj = this;
                        let formData = new FormData();
                        formData.append('id', x);

                        axios.post(this.$api_url+'/salary-banks-delete', formData).then(function(response){

                            if(response.data.success == 1)
                            {
                                this.successmsg = response.data.message;
                                this.$bvToast.toast(response.data.message, {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });
                                this.getBankData();
                            }else{
                                this.$bvToast.toast(response.data.message, {
                                            title: `Error`,
                                            variant: 'danger',
                                            solid: true
                                        });
                                this.getBankData();
                            }
                            this.showoverlay_list = false;


                        }.bind(this))
                        .catch(function (error)
                        {
                            currentObj.showoverlay_list = false;
                            currentObj.serverError(error);
                        });
                    }
                })

            },
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            resetForm()
            {
                this.fdata = {
                    employee_id : this.employee_id,
                    id: '',
                    payment_bank_name: null,
                    payment_bank_percentage: null,
                };

                this.$nextTick(() => {
                    this.$validator.reset();
                });
            },
            addNew()
            {
                this.resetForm();
                this.fdata.employee_id = this.employee_id;
                this.$bvModal.show('bv-modal-payment-bank');
                // alpha fix- added this
                this.payment_bank_info = "Add Payment Bank Info";
            },
            onSubmit(e)
            {
                if(!this.checkNet()) return false;
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }
                    this.showoverlay_list = true;
                    let currentObj = this;
                    e.preventDefault();

                    const config = {
                        //headers: { 'content-type': 'multipart/form-data' }
                    }
                    let formData = new FormData();
                    for (let [key, value] of Object.entries(this.fdata))
                    {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);
                        //console.log(`${key}: ${value}`);
                    }
                    axios.post(this.$api_url+'/save-employee-payment-bank-info', formData, config)
                        .then(function (response)
                        {
                            if(response.data.success){
                                this.$bvToast.toast('Bank Data Saved!', {title: `Success`,variant: 'success',solid: true});
                            }else if(response.data.error){
                                this.$bvToast.toast(response.data.message, {title: `Error`,variant: 'danger',solid: true});
                            }
                            this.$bvModal.hide('bv-modal-payment-bank');
                            this.getBankData();
                            this.showoverlay_list = false;
                            this.resetForm();
                            this.$validator.reset();

                        }.bind(this))
                        .catch(function (error)
                        {
                            currentObj.showoverlay_list = false;
                            currentObj.serverError(error);
                        });
                });
            },
            updateAllEmployeeBankInfo()
            {
                axios.get(this.$api_url+'/update-all-employee-bank-info')
                        .then(function (response) {
                            console.log(response.data);
                        })
                        .catch(function (error) {

    					   currentObj.output = error;

    				    });
            },

            getSelectedBanks: function()
            {
                axios.get(this.$api_url+'/get-payment-selcted-banks' , {
                    params: {
                    }
                }).then(function(response){
                    this.checked_banks = response.data;
                    for (var f_key in this.checked_banks) {
                     this.selected_banks[this.checked_banks[f_key]] = 1;
                    }
                }.bind(this));
            },

        },
        created: function(){
            this.getBankList();
            this.getBankData();
            this.getSelectedBanks();
            //this.updateAllEmployeeBankInfo();
        }
    }
</script>
